import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";

import { RootBlock } from "./RootBlock";
import { defaultData } from "./RootDefaultData";
import { meta } from "./RootMetaData";

export const Root: BlockExport = {
  type: "component",
  Block: RootBlock,
  defaultData,
  meta,
};
